<template>
  <div>
    <!-- 输入框 -->
    <a-input :type="type" v-model:value="state.phone" @blur="inputEnterBlur" @pressEnter="inputEnterBlur" :placeholder="props.placeholder">
      <template #suffix>
        <a-tooltip :title="props.suffixTitle">
          <InfoCircleOutlined style="color: rgba(0, 0, 0, 0.45)" />
        </a-tooltip>
      </template>
      <!-- 输入框后缀提示 -->
    </a-input>
    <div>
      <!-- 手机号列表 -->
      <div v-for="(item, index) in state.phoneList" :key="index" class="phone-item">
        <div>{{ item ? item : '-' }}</div>
        <!-- 删除按钮 -->
        <DeleteOutlined style="cursor: pointer" @click="deleteClick(index)" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { reactive, watch } from 'vue'
import { message } from 'ant-design-vue'
import { DeleteOutlined, InfoCircleOutlined } from '@ant-design/icons-vue'
const emit = defineEmits(['update:value', 'change'])
const props = defineProps({
  value: {
    type: String
  },
  placeholder: {
    type: String
  },
  suffixTitle: {
    type: String
  },
  inputType: {
    type: String
  },
  type: {
    type: String,
    default: 'text'
  }
})
interface state {
  phone: string
  phoneList: string[]
}
const state = reactive<state>({
  phone: '',
  phoneList: []
})
watch(
  () => props.value,
  (val) => {
    if (val && val.length > 0) {
      state.phoneList = val.split(',')
    }
  },
  {
    deep: true,
    immediate: true
  }
)
// 验证手机号码格式
const validatePhoneNumber = (phoneNumber) => {
  var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
  return reg_tel.test(phoneNumber)
}
// 添加手机号码
const addPhoneNumber = (phoneNumber: string) => {
  if (phoneNumber && phoneNumber.length > 0) {
    if (props.inputType == 'number') {
      if (!validatePhoneNumber(phoneNumber)) {
        message.error('请输入正确的手机号码')
        return
      }
    }
    if (!state.phoneList.includes(phoneNumber)) {
      state.phoneList.push(phoneNumber)
    }
    state.phone = ''
    emit('update:value', state.phoneList.join(','))
    emit('change', state.phoneList.join(','))
  }
}
//
const inputEnterBlur = (val) => {
  addPhoneNumber(val.target.value)
}
// 删除手机号码
const deleteClick = (index) => {
  state.phoneList.splice(index, 1)
  emit('update:value', state.phoneList.join(','))
}
</script>

<style lang="less" scoped>
.phone-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
